module.exports = __webpack_public_path__ + "img/nvHai3.b216d292.png";